import { Plot } from '../shared/types';

export type AnalysisType = 'EUFOROBS' | 'PRECISION';

export const hasAnalysis = (type: AnalysisType, plot: Plot | undefined) => {
  return plot?.mostRecentAnalysesByType?.[type] !== null;
};
